module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<ul>\n<%\nif(environment.style != 'mobile'){\nutils.forEach(model.elements, function(routeComponentID, subMenuName){\n%>\n<li data-route-component-id=\"<%- routeComponentID %>\" class=\"<%- (routeComponentID == model.activeRouteComponentID ? 'active' : '') %>\"><a><%= subMenuName %></a></li>\n<%\n});\n}\n%>\n</ul>"
  , __filename = "components/templates/headPanel/columnMenu.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<ul>\n")
    ; __line = 2
    ; 
if(environment.style != 'mobile'){
utils.forEach(model.elements, function(routeComponentID, subMenuName){

    ; __line = 5
    ; __append("\n<li data-route-component-id=\"")
    ; __line = 6
    ; __append( routeComponentID )
    ; __append("\" class=\"")
    ; __append( (routeComponentID == model.activeRouteComponentID ? 'active' : '') )
    ; __append("\"><a>")
    ; __append(escapeFn( subMenuName ))
    ; __append("</a></li>\n")
    ; __line = 7
    ; 
});
}

    ; __line = 10
    ; __append("\n</ul>")
    ; __line = 11
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components/templates/headPanel/columnMenu.ejs

}